import styled from '@emotion/styled'
import TextArea from 'components/TextArea'

const GrowingTextAreaSt = styled(TextArea)`
  resize: none;
  min-height: var(--chakra-sizes-10);
`

export { GrowingTextAreaSt }
